import { render, staticRenderFns } from "./rule13.vue?vue&type=template&id=14306dbf&scoped=true"
import script from "./rule13.vue?vue&type=script&lang=js"
export * from "./rule13.vue?vue&type=script&lang=js"
import style0 from "./rule13.vue?vue&type=style&index=0&id=14306dbf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14306dbf",
  null
  
)

export default component.exports